// Injects Supabase URL/key into runtimeConfig before @nuxtjs/supabase plugin runs.
// Values are baked at build time via vite.define in nuxt.config.ts.
// order: -50 ensures this runs before @nuxtjs/supabase plugin (order: -20).
export default defineNuxtPlugin({
  name: 'supabase-config-override',
  enforce: 'pre',
  order: -50,
  setup () {
    const config = useRuntimeConfig()
    if (!config.public.supabase) {
      (config.public as Record<string, unknown>).supabase = {}
    }
    const supabase = config.public.supabase as Record<string, string>
    supabase.url = __SUPABASE_URL__
    supabase.key = __SUPABASE_KEY__
  },
})
